<template>
<div class="information_container">
  <el-tabs v-model="activeName">
    <el-tab-pane :label="$t('loginSecurity')" name="second">
      <div class="detail_container">
        <div class="each_info">
          <span class="descriptions">{{ $t('email') }}</span>
          <span>{{customerInformation.email}}</span>
          <span class="btn_link">
              <p v-if="customerInformation.verify_email">{{ $t('verified') }}</p>
              <p v-else @click="handleVerifyEmailClick">
                {{ $t('verify') }}
              </p>
          </span></div>
        <div class="each_info">
          <span class="descriptions">{{ $t('password') }}</span>
          <span>**************</span>
          <span class="btn_link" @click="dialogFormVisible = true">{{ $t('change') }}</span>
        </div>
        <div class="each_info"><span class="descriptions">{{ $t('phone') }}</span><span>{{customerInformation.Phone ? customerInformation.Phone : 'None'}}</span><span class="btn_link">
            <el-tooltip class="item" effect="dark" content="Developers are working on it" placement="right-start">
              <p>{{ $t('edit') }}</p>
            </el-tooltip>
          </span></div>
      </div>  
    </el-tab-pane>
    <el-tab-pane :label="$t('linkAccount')" name="third">
      <div class="detail_container">
        <div class="each_info"><span class="descriptions"><img :src="WechatIcon" alt=""></span><span>{{ $t('wechat') }}</span><span class="btn_link">
            <el-tooltip class="item" effect="dark" content="Coming up soon" placement="right-start">
              <p>{{ $t('link') }}</p>
            </el-tooltip>
          </span></div>
        <div class="each_info">
          <span class="descriptions">
            <img :src="FacebookIcon" alt="">
          </span>
          <span>Facebook</span>
          <span class="btn_link">
            <el-tooltip class="item" effect="dark" content="Coming up soon" placement="right-start">
              <p>
                {{ $t('link') }}
              </p>
            </el-tooltip>
          </span>
        </div>
      </div>
    </el-tab-pane>
  </el-tabs>
  <!-- <div class='security_link'>
    <h4 class="subtitle">{{ $t('loginSecurity') }}</h4>
    <div class="detail_container">
      <div class="each_info"><span class="descriptions">{{ $t('email') }}</span><span>{{customerInformation.email}}</span><span class="btn_link">
            <p v-if="customerInformation.verify_email">{{ $t('verified') }}</p>
            <p v-else @click="handleVerifyEmailClick">
              {{ $t('verify') }}
            </p>
        </span></div>
      <div class="each_info"><span class="descriptions">{{ $t('password') }}</span><span>**************</span><span class="btn_link" @click="dialogFormVisible = true">{{ $t('change') }}</span></div>
      <div class="each_info"><span class="descriptions">{{ $t('phone') }}</span><span>{{customerInformation.Phone ? customerInformation.Phone : 'None'}}</span><span class="btn_link">
          <el-tooltip class="item" effect="dark" content="Developers are working on it" placement="right-start">
            <p>
              {{ $t('edit') }}
            </p>
          </el-tooltip>
        </span></div>
    </div>
  </div>
  <div class='security_link'>
    <h4 class="subtitle">{{ $t('linkAccount') }}</h4>
    <div class="detail_container">
      <div class="each_info"><span class="descriptions"><img :src="WechatIcon" alt=""></span><span>{{ $t('wechat') }}</span><span class="btn_link">
          <el-tooltip class="item" effect="dark" content="Coming up soon" placement="right-start">
            <p>
              {{ $t('link') }}
            </p>
          </el-tooltip>
        </span></div>
      <div class="each_info"><span class="descriptions"><img :src="FacebookIcon" alt=""></span><span>Facebook</span><span class="btn_link">
          <el-tooltip class="item" effect="dark" content="Coming up soon" placement="right-start">
            <p>
              {{ $t('link') }}
            </p>
          </el-tooltip>
        </span>
      </div>
    </div>
  </div> -->

  <el-dialog title="Change Password" :visible.sync="dialogFormVisible" :beforeClose="handleDialogBeforeClose" :width="windowWidth > 800 ? '30%' : '80%'" class="modal">
    <el-form :model="form" :rules="rules">
      <el-form-item prop="old_password">
        <el-input placeholder="Current Password" v-model="form.old_password" type='password'></el-input>
      </el-form-item>
      <el-form-item prop="new_password">
        <el-input placeholder="New Password" v-model="form.new_password" type='password'></el-input>
      </el-form-item>
      <el-form-item prop="newPasswordAgain">
        <el-input placeholder="Reenter New Password" v-model="form.newPasswordAgain" type='password'></el-input>
      </el-form-item>
      <p v-if='form.passwordNotMatch'>{{ $t('passwordMatch') }}</p>
      <p v-if="form.oldPasswordNotMatch">{{ $t('passwordWrong') }}</p>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="handlePasswordChangeSubmit($event, form)" class="confirmBtn">{{ $t('confirm') }}</el-button>
    </span>
  </el-dialog>

</div>
</template>

<script>
import WechatIcon from '../../assets/img/wechatnew1.png'
import WeiboIcon from '../../assets/img/weibo-icon.png'
import FacebookIcon from '../../assets/img/facebook_circle-512.png'
import {
  mapActions,
  mapState,
} from 'vuex'
export default {
  name: 'account-info',
  data() {
    return {
      activeName:'second',
      stateOptions: this.$store.state.addresses.states,
      WechatIcon: WechatIcon,
      WeiboIcon: WeiboIcon,
      FacebookIcon: FacebookIcon,
      form: {
        old_password: '',
        new_password: '',
        newPasswordAgain: '',
        passwordNotMatch: false,
        oldPasswordNotMatch: false,
      },
      rules: {

      },
      dialogFormVisible: false,
      windowWidth: document.documentElement.clientWidth,

      email: '',
      phone: '',
    }
  },
  methods: {
    ...mapActions('auth', ['changePassword', 'fetchCustomerInformation']),
    ...mapActions('profile', ['verifyEmail']),
    handleVerifyEmailClick() {
      console.log('you clicked on verify email', this);
      return;
      this.verifyEmail()
      .then(res => {
        this.$alert('An Confirmation Email has been sent to you email address', 'Success', {
          confirmButtonText: 'OK',
          type: 'success',
          center: true
        }).then(() => {
          // this.dialogVisible = false;
        }).catch(() => {});
      })
      .catch(err => console.log('err verifying email address', address))
    },
    clearFormData() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    handleDialogBeforeClose() {
      this.clearFormData();
      this.dialogFormVisible = false;
    },
    handleResize(size) {
      this.windowWidth = document.documentElement.clientWidth
    },
    showPwChangedAlert() {
      this.$alert('You have successfully changed account password', 'Success', {
        confirmButtonText: 'OK',
        type: 'success',
        center: true
      }).then(() => {
        // this.dialogVisible = false;
      }).catch(() => {});
    },
    handlePasswordChangeSubmit(event, form) {
      event.preventDefault();
      this.form.passwordNotMatch = false;
      if (form.new_password !== form.newPasswordAgain) {
        this.form.passwordNotMatch = true;
        return
      }
      const data = {
        new_password: form.new_password,
        old_password: form.old_password,
      }
      this.changePassword(data)
        .then(res => {
          this.dialogFormVisible = false;
          this.clearFormData();
          this.showPwChangedAlert();
        })
        .catch(err => {
          this.form.oldPasswordNotMatch = true;
          return;
        })
    }
  },
  mounted: function () {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  },
  computed: mapState({
    customerInformation: state => state.auth.userDetails,
  })
}
</script>

<style lang="less" scope>
.information_container {
  max-width: 800px;

  .el-tabs{
    .el-tabs__header{
      .el-tabs__nav-wrap{
        .el-tabs__nav{
          .el-tabs__active-bar{
            background-color: #29327F;
          }
          .is-active{
            color: #29327F;
          }
        }
      }
    }
  }

  .detail_container {

    .each_info {
      line-height: 50px;
    }

    .descriptions {
      color: grey;
      display: inline-block;
      width: 100px;
      color: #333333;
      img {
        vertical-align: middle;
      }
    }

    span {
      color: #999999;
      img {
        width: 40px;
        border-radius: 50%;
      }
    }
    
    .btn_link {
      float: right;
      color: #29327F;
    }

    img {
      width: 40px;
      border-radius: 50%;
    }

    .btn_link {
      text-decoration: underline;
      cursor: pointer;
    }

    .btn_link:hover {
      color: #BCC3D9
    }
  }

  .confirmBtn {
    background-color: #29327F;
    border: 1px transparent solid;
  }

  .el-input__inner {
    background-color: #fce4bd;
    color: #000;
    border: none;
    border-radius: 5px;
  }

  input::-webkit-input-placeholder {
    color: #000000;
  }

  input::-ms-input-placeholder {
    color: #000000;
  }

  .subtitle {
    margin: 5% 0;
  }

  .header_container {
    border-bottom: 1px solid silver;
    padding-bottom: 12px;
  }


  .modal {
    margin-top: 100px;
  }

}

@media only screen and (max-width: 768px) {
  .information_container {
    .detail_container {
      .descriptions {
        width: 60px;
      }
      span{
        font-size: 12px;
      }
    }
  }
}

@media only screen and (max-width: 490px) {
  .information_container {
    .el-tabs{
      .el-tabs__header{
        .el-tabs__nav-wrap{
          .el-tabs__nav{
            .el-tabs__active-bar{
              background-color: #29327F;
            }
            .is-active{
              color: #29327F;
            }
            .el-tabs__item{
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}


</style>



// WEBPACK FOOTER //
// src/view/Profile/information.vue